import {PIXI} from '@colonist/pixi'
import {Viewport} from 'pixi-viewport'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView.ts'
import {UIGameMapViewLayers} from './UIGameMapViewLayers.ts'
import type {ZoomedEvent} from 'pixi-viewport/dist/types.js'
import {type HexFace, type Point} from '@colonist/game-mechanic-validators'

export class UIGameMapView extends Viewport {
    mapCenter: Point
    originalWidth: number
    originalHeight: number
    hexagonHeight: number
    hexagonWidth: number
    robberRadius: number
    pirateRadius: number
    merchantRadius: number
    cornerCircleR: number
    layers: UIGameMapViewLayers

    DEFAULT_ZOOM_EVENT: ZoomedEvent = {
        type: 'animate',
        viewport: this,
    }

    constructor(x: number, y: number, w: number, h: number, app: PIXI.Application) {
        super({
            screenWidth: w,
            screenHeight: h,
            events: app.renderer.events,
        })
        const bg = new SectionBgView(x, y, w, h, this)
        app.stage.addChild(this)

        // activate plugins
        this
            .drag()
            .pinch()
            .wheel()

        this.initMapSizes()
        this.originalWidth = w
        this.originalHeight = h

        this.layers = new UIGameMapViewLayers()
    }

    private initMapSizes() {
        this.hexagonHeight = this.height / 5.3 // because it looks good
        this.hexagonWidth = this.hexagonHeight / 2 * Math.sqrt(3)
        this.robberRadius = this.hexagonHeight / 2.7
        this.pirateRadius = this.hexagonHeight / 3
        this.merchantRadius = this.hexagonHeight / 4.7
        this.cornerCircleR = this.hexagonHeight / 5.2 // it is 5.2 because it looks good
    }

    repositionMap(location: Point) {
        this.left = location.x
        this.top = location.y
    }

    disableInteraction() {
        this.plugins.pause('drag')
        this.plugins.pause('pinch')
        this.plugins.pause('wheel')
        this.plugins.pause('decelerate')
        this.plugins.pause('clamp')
        this.plugins.pause('clampZoom')
        this.interactiveChildren = false
    }

    enableInteraction() {
        this.plugins.resume('drag')
        this.plugins.resume('pinch')
        this.plugins.resume('wheel')
        this.plugins.resume('decelerate')
        this.plugins.resume('clamp')
        this.plugins.resume('clampZoom')
        this.interactiveChildren = true
    }

    getTileLeftCenterCircle(hexFace: HexFace): PIXI.Circle {
        const tileCenter = hexFace.toPixel(this.mapCenter, this.hexagonHeight / 2)
        return new PIXI.Circle(tileCenter.x, tileCenter.y - this.hexagonHeight / 6, this.hexagonHeight / 6)
    }
}
